import { render, staticRenderFns } from "./iconHorloge.vue?vue&type=template&id=566124ee"
import script from "./iconHorloge.vue?vue&type=script&lang=js"
export * from "./iconHorloge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports